import { render, staticRenderFns } from "./KeenMessageAddressInput.vue?vue&type=template&id=352b0bad&scoped=true"
import script from "./KeenMessageAddressInput.vue?vue&type=script&lang=js"
export * from "./KeenMessageAddressInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b0bad",
  null
  
)

export default component.exports